import { AppSettingsRepo, SettingsKeys } from '../../../domain/settings/IAppSettingsRepo';
import getStunOnlySetting from './getStunOnlySetting';

const toggleStunOnlySetting = async () => {
	const stunOnly = await getStunOnlySetting();
	await AppSettingsRepo.set(SettingsKeys.stunOnly, !stunOnly)
	return !stunOnly;
}

export default toggleStunOnlySetting;